// const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";


const API_BASE = "https://app.smigc.in";




const get = async (symbol, range, interval) => {
  const r = await fetch(
    `${API_BASE}/api/market/yahoo?symbol=${encodeURIComponent(symbol)}&range=${range}&interval=${interval}`
  );
  const d = await r.json();
  if (!r.ok) throw new Error(d.error || "Data nahi mila");
  return d;
};

export const fetchIndiaQuote = async (symbol) => (await get(symbol, "1d", "5m")).quote;

const RANGE_MAP = { "1D": ["1d", "5m"], "1M": ["1mo", "1d"], "6M": ["6mo", "1d"], "1Y": ["1y", "1d"] };

export const fetchIndiaChart = async (symbol, range) => {
  const [r, i] = RANGE_MAP[range];
  return (await get(symbol, r, i)).candles;
};